const KEY = 'ncc.pendingEmail';

/** Where a confirmation link should return: the origin that asked for it (a PR worker, dev, production). */
export function confirmationRedirect(path = '/'): string {
  return `${window.location.origin}${path}`;
}

/** Remembers the address awaiting confirmation for this tab only, so a reload of the page still names it. */
export function rememberPendingEmail(email: string): void {
  try {
    sessionStorage.setItem(KEY, email);
  } catch {
    // storage may be unavailable (private mode); the page then shows its generic text
  }
}

/** The address remembered by `rememberPendingEmail`, or null where storage is unavailable or nothing is pending. */
export function pendingEmail(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}
